<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular"
>
  <div
    *ngIf="label"
    class="form-field-label {{ type }}"
  >
    {{ label }}
    <span
      *ngIf="isRequired"
      class="required-mark"
      >*</span
    >
  </div>
  <div>
    <mat-form-field
      [formGroup]="parentFormGroup"
      [ngClass]="{
        'enabled-clear-selection':
          enableClearSelection &&
          parentFormGroup.controls[controlName].value &&
          parentFormGroup.controls[controlName].status !== 'DISABLED',
        small: type,
      }"
      appearance="outline"
      class="form-field w-full"
      hideRequiredMarker
    >
      <mat-select
        #select
        [formControlName]="controlName"
        [multiple]="enableMultiple"
        [ngClass]="{
          'enabled-clear-selections':
            parentFormGroup.controls[controlName].status !== 'DISABLED' &&
            enableClearSelection &&
            parentFormGroup.getRawValue()[controlName],
        }"
        [panelClass]="optionsPanelClassName"
        [placeholder]="placeholder"
        class="select {{ type }}"
      >
        <mat-select-trigger
          *ngIf="!enableMultiple && parentFormGroup.getRawValue()[controlName]"
        >
          <div class="flex items-center">
            {{ getSelectedValue() }}
            <app-icon
              *ngIf="getSelectedIntensityIcon()"
              [svgIcon]="getSelectedIntensityIcon()"
              class="ml-2"
            ></app-icon>
          </div>
        </mat-select-trigger>
        <div
          (scrolled)="getNext()"
          [alwaysCallback]="true"
          [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [scrollWindow]="false"
          class="h-full overflow-auto"
          infinite-scroll
        >
          <mat-option
            class="search-option"
            *ngIf="enableSearch"
          >
            <ngx-mat-select-search
              [formControlName]="filterControlName"
              [placeholderLabel]="searchPlaceholder"
              [clearSearchInput]="false"
              class="mat-search-select-input-container search remove-ripple ripple"
              noEntriesFoundLabel="No entry matches"
            >
            </ngx-mat-select-search>
          </mat-option>
          <div *ngIf="options?.length; else noData">
            <div
              *ngIf="!!enableAllSelection && enableMultiple"
              [class.all-selected]="isChecked()"
              class="all-label-wrapper"
            >
              <mat-checkbox
                (change)="toggleSelection($event)"
                (click)="$event.stopPropagation()"
                [checked]="isChecked()"
                [indeterminate]="isIndeterminate()"
                class="checkbox"
              >
                <span
                  class="all-label"
                  [class.selected-label]="isChecked()"
                >
                  All
                </span>
              </mat-checkbox>
            </div>
            <mat-option
              *ngFor="let option of options; let i = index"
              [disabled]="
                (option.key !== -1 && optionsDisabled) || option.disabled
              "
              [ngClass]="type ? 'small' : ''"
              [value]="option.key"
              class="single-select-option"
            >
              <div class="flex items-center">
                {{ option.value }}
                <app-icon
                  *ngIf="getIntensityIcon(option.value)"
                  [svgIcon]="getIntensityIcon(option.value)"
                  class="ml-2"
                ></app-icon>
              </div>
            </mat-option>
          </div>
          <ng-template #noData>
            <mat-option
              class="no-data"
              *ngIf="!loading"
              disabled
            >
              No options available
            </mat-option>
          </ng-template>
          <mat-option
            *ngIf="loading"
            class="dropdown-loading"
            disabled
          >
            <mat-spinner
              [diameter]="20"
              class="dropdown-loader"
              mode="indeterminate"
            >
            </mat-spinner>
          </mat-option>
        </div>
      </mat-select>
      <mat-icon
        (click)="clearSelection($event)"
        *ngIf="
          parentFormGroup.controls[this.controlName].status !== 'DISABLED' &&
          ((!enableMultiple &&
            enableClearSelection &&
            parentFormGroup.getRawValue()[controlName]) ||
            (enableMultiple &&
              enableClearSelection &&
              parentFormGroup.getRawValue()[controlName]?.length))
        "
        class="clear-selection text-palo-verde"
        matSuffix
        matTooltip="Clear"
        >close
      </mat-icon>
      <mat-error *ngIf="error">{{ error }}</mat-error>
    </mat-form-field>
  </div>
</div>
